export type TPrivacySection = {
  key: string;
  paragraphs?: readonly string[];
  bullets?: readonly string[];
};

export const PRIVACY_SECTIONS: readonly TPrivacySection[] = [
  {
    key: 'data.controller',
    paragraphs: ['line1'],
  },
  {
    key: 'data.we.collect',
    paragraphs: ['line1'],
    bullets: ['item1', 'item2', 'item3', 'item4'],
  },
  {
    key: 'purpose.of.processing',
    paragraphs: ['line1', 'line2'],
    bullets: ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7'],
  },
  {
    key: 'data.sharing',
    paragraphs: ['line1', 'line2'],
    bullets: ['item1', 'item2'],
  },
  {
    key: 'data.retention',
    paragraphs: ['line1'],
    bullets: ['item1', 'item2'],
  },
  {
    key: 'user.rights',
    paragraphs: ['line1'],
    bullets: ['item1', 'item2', 'item3', 'item4', 'item5'],
  },
  {
    key: 'cookies',
    paragraphs: ['line1'],
    bullets: ['item1', 'item2'],
  },
  {
    key: 'contact',
    paragraphs: ['line1'],
  },
] as const;
